//import Vue from 'vue'
// import router from '@/router'
//import firebase from 'firebase'
//import authService from '@/services/auth'
// import moment from "moment-timezone";

export default {
    namespaced: true,
    state: {
      token: null,
      isLoggedIn: !!localStorage.getItem('token'),
      hasError: false
    },
    mutations: {
      loginUser (state, token) {
          localStorage.setItem('token', token)
          state.isLoggedIn = true,
          state.token = token;
      },
      logoutUser (state) {
          state.isLoggedIn = false
      },
      setAlert(state){
        state.hasError = true;
        console.log('set alert');
      }
    },
    actions: {
      logout(context){
        // localStorage.removeItem('token')
        context.commit('logoutUser');
      },
      setAlert(state){
        state.hasError = true;
        console.log('set alert');
      }
    },
    getters: {
      checkLogin : state => {
        return (state.isLoggedIn) ?true:false
      },
      user: state =>{
        return null;
      },
      hasError : state =>{
        return state.hasError
      }
    }
  }